/**
 * Common UI and styling type definitions
 */

/**
 * CSS word-break property values
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/word-break
 */
export enum WordBreakStyle {
  Normal = 'normal',
  BreakAll = 'break-all',
  KeepAll = 'keep-all',
  BreakWord = 'break-word',
}
